module.exports = __webpack_public_path__ + "img/zimi-thumbnail.417a7c61.png";